import React, { type ReactNode } from 'react';
import { token } from '@atlaskit/tokens';

type Props = {
	children: ReactNode;
};

export const IllustrationBlobBackground = ({ children }: Props) => (
	<svg
		width="720"
		height="586"
		viewBox="0 0 720 586"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M370.025 17.9079C434.256 22.6735 503.767 7.79394 556.943 40.6745C610.66 73.8893 624.33 136.807 649.809 190.907C678.228 251.252 739.504 312.537 713.872 373.89C688.153 435.452 591.852 436.828 531.607 473.835C474.196 509.102 439.255 580.301 370.025 585.109C300.167 589.961 241.321 540.007 189.315 497.609C141.938 458.986 117.437 406.978 88.5028 355.603C53.1707 292.869 -12.2428 234.212 1.99552 165.015C16.473 94.6556 86.9077 40.1425 159.374 11.1767C225.234 -15.1486 298.243 12.582 370.025 17.9079Z"
			fill={token('color.icon.accent.blue', '#2684FF')}
		/>
		{children}
	</svg>
);
